import React, { useCallback } from 'react';

import { PDFDataContextProvider } from './context';
import {
  pagesFilterFnForAboutSafari,
  pagesFilterFnForPages,
  pagesFilterFnForTermsPages,
  useAllPagesReady,
  usePrint,
} from './functions';
import s from './index.module.css';
import CoverPage from './Pages/CoverPage';
import OtherPages from './Pages/OtherPages';
import Relocations from './Pages/Relocations';
import SafariCosts from './Pages/SafariCosts';
import SafariOverviewDetails from './Pages/SafariOverviewDetails';
import SafariOverviewMap from './Pages/SafariOverviewMap';
import TripManifest from './Pages/TripManifest';

const defaultConfig = {
  showSafariMapPage: true,
  showSafariDetailsPage: true,
  showManifestTablePage: true,
  showSafariCostsPage: true,
  showRelocationsPage: true,
};

function PDFPreview({ onReady, config = defaultConfig, data, showImages }) {
  config = { ...defaultConfig, ...config };

  const { canvasRef, numeratePages, allImagesLoaded } = usePrint();
  const handleAllPagesReady = useCallback(async () => {
    try {
      console.log('---- handleAllPagesReady v2 start');
      numeratePages();
      console.log('---- handleAllPagesReady v2 numeratePages finished');
      await allImagesLoaded();
      console.log('---- handleAllPagesReady v2 allImagesLoaded finished');
      onReady();
      console.log('---- handleAllPagesReady v2 onReady finished');
    } catch (e) {
      console.log('---- handleAllPagesReady v2 e', e);
    }
  }, [numeratePages, onReady, allImagesLoaded]);
  const {
    setCoverReady,
    setAboutSafariReady,
    setMapReady,
    setDetailsReady,
    setPagesReady,
    setTermsPagesReady,
    setSafariCostsReady,
    setTripManifestReady,
    setRelocationsReady,
  } = useAllPagesReady({ config, onReady: handleAllPagesReady });

  return (
    <PDFDataContextProvider data={data} showImages={showImages}>
      <div className={s.container} ref={canvasRef}>
        <CoverPage onReady={setCoverReady} />
        <OtherPages pagesFilterFn={pagesFilterFnForAboutSafari} onReady={setAboutSafariReady} />
        {config.showSafariMapPage && <SafariOverviewMap onReady={setMapReady} />}
        {config.showSafariDetailsPage && <SafariOverviewDetails onReady={setDetailsReady} />}
        <OtherPages pagesFilterFn={pagesFilterFnForPages} onReady={setPagesReady} />
        {config.showManifestTablePage && <TripManifest onReady={setTripManifestReady} />}
        {config.showRelocationsPage && <Relocations onReady={setRelocationsReady} />}
        {config.showSafariCostsPage && <SafariCosts onReady={setSafariCostsReady} />}
        <OtherPages pagesFilterFn={pagesFilterFnForTermsPages} onReady={setTermsPagesReady} />
      </div>
    </PDFDataContextProvider>
  );
}

export default PDFPreview;
